import React from "react";
import "../styles/About.css";
import { FaCheckCircle } from "react-icons/fa";
import { useTheme } from "../contexts/ThemeContext";
import { useLanguage } from "../contexts/LanguageContext";

const About: React.FC = () => {
  const { theme } = useTheme();
  const { t } = useLanguage();
  const logoSource = theme === 'light' 
    ? require("../assets/images/amblem_light.png")
    : require("../assets/images/amblemlight2.png");

  return (
    <div className="about-container">
      <div className="breadcrumb">{t('about.breadcrumb')}</div>
      <img src={logoSource} alt="Logo" className="about-logo enlarged-logo" />

      <h2 className="about-section-title">{t('about.greeting')}</h2>
      <p className="about-text"><FaCheckCircle className="icon gold-icon" />{t('about.paragraph1')}</p>
      <p className="about-text"><FaCheckCircle className="icon gold-icon" />{t('about.paragraph2')}</p>
      <p className="about-text"><FaCheckCircle className="icon gold-icon" />{t('about.paragraph3')}</p>

      <h2 className="about-section-title">{t('about.vision')}</h2>
      <p className="about-text"><FaCheckCircle className="icon gold-icon" />{t('about.visionText')}</p>

      <h2 className="about-section-title">{t('about.mission')}</h2>
      <p className="about-text"><FaCheckCircle className="icon gold-icon" />{t('about.missionText')}</p>

      <h2 className="about-section-title">{t('about.values')}</h2>
      <p className="about-text"><FaCheckCircle className="icon gold-icon" />{t('about.value1')}</p>
      <p className="about-text"><FaCheckCircle className="icon gold-icon" />{t('about.value2')}</p>
      <p className="about-text"><FaCheckCircle className="icon gold-icon" />{t('about.value3')}</p>
      <p className="about-text"><FaCheckCircle className="icon gold-icon" />{t('about.value4')}</p>
      <p className="about-text"><FaCheckCircle className="icon gold-icon" />{t('about.value5')}</p>
      <p className="about-text"><FaCheckCircle className="icon gold-icon" />{t('about.value6')}</p>
      <p className="about-text"><FaCheckCircle className="icon gold-icon" />{t('about.value7')}</p>
      <p className="about-text"><FaCheckCircle className="icon gold-icon" />{t('about.value8')}</p>
      <p className="about-text"><FaCheckCircle className="icon gold-icon" />{t('about.value9')}</p>
      <p className="about-text"><FaCheckCircle className="icon gold-icon" />{t('about.value10')}</p>
      <p className="about-text"><FaCheckCircle className="icon gold-icon" />{t('about.value11')}</p>

      <h2 className="about-section-title">{t('about.activities')}</h2>
      <p className="about-text"><FaCheckCircle className="icon gold-icon" />{t('about.activitiesText')}</p>
    </div>
  );
};

export default About;
